import { DefaultKanbanBoardFragment } from "@graphql";
import { BoardDescription, ColumnDescription } from "./kanban-types";

export function mapDataToBoard(data: DefaultKanbanBoardFragment) {
  const b: BoardDescription<any> = {
    id: data._id,
    title: data.name,
    columns: []
  };

  for (const column of data.columns) {
    const col: ColumnDescription<any> = {
      id: column._id,
      title: column.name,
      cards: []
    };

    b.columns.push(col);
  }

  return b;
}
